module.exports = __webpack_public_path__ + "img/xxaqgltxrzzs.b53a46ce.png";